import { Device } from '@app/services/types';

export const isSensor = ({ datafmt }: Device) => datafmt.startsWith('sensor');

export const deviceTitle = (device: Device) => `${device.name} (${device.did})`;
